export function buildGuestExecutiveBriefingData() {
  return {
    timeTracking: {
      activeCount: 3,
      onBreakCount: 1,
      selfSession: null,
    },
    payroll: {
      grossPay: 42850,
      overtimeHours: 12.5,
    },
    accountsReceivable: {
      invoiceCount: 4,
      outstandingReceivables: 18500,
    },
    accountsPayable: {
      payrollLiability: 9200,
      unpaidEntries: 6,
    },
    estimates: {
      draftCount: 2,
      awaitingApprovalCount: 1,
    },
  };
}
